/**
 * Prevents redundant API calls when navigating between sections.
 *
 * Usage:
 *   import fetchOnceMixin from '@/mixins/fetchOnceMixin'
 *   export default { mixins: [fetchOnceMixin], ... }
 *
 *   fetchOnce('profile', this.loadProfile)   // skips if already loaded
 *   invalidateFetch('profile')               // force re-fetch next time
 */
export default {
  data () {
    return {
      fetchOnceCache: {}
    }
  },
  methods: {
    async fetchOnce (key, loader) {
      if (this.fetchOnceCache[key]) return
      await loader()
      this.$set(this.fetchOnceCache, key, true)
    },
    invalidateFetch (key) {
      this.$set(this.fetchOnceCache, key, false)
    }
  }
}
